import React from 'react';
import { SparkleIcon } from './Icons';
import styles from '../styles/Tip.module.css';

/**
 * Learning Tip chip
 * Rendered from a <Tip:{"text":"..."}> content tag, which Sophia may optionally
 * include after a search_knowledge answer to surface a practical "learning tip".
 *
 * Unlike ArticleCard/VideoCard these link to nothing — the tip text is the whole
 * payload. Styled as a compact inline chip, distinct from the full-width cards.
 *
 * Follows the unified-component pattern: a `variant` prop reserves room for other
 * presentations later; "chat" (inline in a message) is the only one for now.
 */
function Tip({ text, variant = 'chat' }) {
  if (!text) return null;

  return (
    <div className={`${styles.tipBlock} ${styles[variant] || ''}`}>
      <p className={styles.tipIntro}>Based on our conversation here are some Learning Tips:</p>
      <div className={styles.tip} role="note">
        <SparkleIcon size={14} className={styles.tipIcon} />
        <div className={styles.tipBody}>
          <span className={styles.tipLabel}>Learning tip</span>
          <span className={styles.tipText}>{text}</span>
        </div>
      </div>
    </div>
  );
}

export default Tip;
